import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { openJourneyDetail } from 'redux/modules/journeys/effects';
import { launchNotification } from 'utils/notifications';
import useWebsockets from 'utils/hooks/useWebsockets';
import image from 'assets/images/crown.png';

const EVENTS_WITH_NOTIFICATION = ['CREATED', 'OWNER_CHANGED'];

export const useTasksNotifications = () => {
  const me = useSelector((state) => state.me);
  const dispatch = useDispatch();

  const handleRealTimeMessages = useCallback(
    (groupOfTasks) => {
      const { handled_by, update_type, tasks, id } = groupOfTasks || {};

      if (!isHandledByMe(handled_by, me)) return;
      if (!isEventWithNotification(update_type)) return;

      notificationPerEvent({ id, tasks, dispatch })[update_type]();
    },
    [me, dispatch]
  );

  useWebsockets({
    channel: 'journey_summaries',
    event: 'journey_summary_updated',
    eventHandler: handleRealTimeMessages,
  });
};

export function isHandledByMe(handledBy, me) {
  if (!handledBy || !handledBy?.id) return false;
  if (!me || !me?.id) return false;

  return me.id === handledBy.id;
}

export function isEventWithNotification(eventType) {
  return EVENTS_WITH_NOTIFICATION.includes(eventType);
}

export function notificationPerEvent({ id, tasks, dispatch }) {
  const bodies = {
    TASK_TYPE_MANAGE_MANUAL: 'Manual task',
    TASK_TYPE_MANAGE_LATE: 'Late',
    TASK_TYPE_MANAGE_NOT_STARTED: 'Not started',
    TASK_TYPE_MANAGE_OPEN_CHAT: 'Unanswered message',
    TASK_TYPE_MANAGE_DELAY_RISK: 'Risk of delay',
    TASK_TYPE_MANAGE_DELAY_NO_GPS: 'No gps - delay check',
    TASK_TYPE_MANAGE_DELAY: 'Possible delay',
  };

  return {
    CREATED: () => {
      const type = tasks?.length && tasks[0]?.task_type;

      launchNotification({
        title: `New task assigned - J${id}`,
        options: {
          tag: id,
          body: bodies[type],
          icon: image,
        },
        handleClick: handleNotificationClick(id, dispatch),
      });
    },
    OWNER_CHANGED: () => {
      launchNotification({
        title: `New task assigned - J${id}`,
        options: {
          tag: id,
          icon: image,
        },
        handleClick: handleNotificationClick(id, dispatch),
      });
    },
  };
}

export function handleNotificationClick(id, dispatch) {
  return () => {
    dispatch(
      openJourneyDetail({
        id,
        tab: '/tasks',
      })
    );
  };
}
